import { createSurveyStyles } from '@sm/webassets';
import { WrenchTheme } from '@wds/styles';

const useStyles = createSurveyStyles(surveyTheme => ({
  anchorElement: {
    fontSize: 12,
    lineHeight: '18px',
    textDecoration: 'underline',
    display: 'block',
    textAlign: 'center',
    margin: '0 auto',
    color: surveyTheme.questionColor,
    fontFamily: WrenchTheme.type.fontFamily.base,
  },
}));

export default useStyles;
